// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from 'react';
// eslint-disable-next-line no-unused-vars
import { FxPageContainer } from 'axp-fx-common';
import { useSelector } from 'react-redux';
// eslint-disable-next-line no-unused-vars
import ContactInformationDirectory from './ContactInformationDirectory';
// eslint-disable-next-line no-unused-vars
import UpdateContact from '../../Common/UpdateContact/UpdateContact';
import {
  contactInformationBreadcrumbs,
  updateContactBreadcrumb,
} from '../../../constants/breadcrumbs';
import actionType from '../../../constants/actionType';
import { fetchDialCodes } from '../../../utils/apiUtil';

const ContactInformation = () => {
  const [stepNo, setStepNo] = useState(1);
  const [selectedContact, setSelectedContact] = useState([]);

  const [dialCodes, setDialCodes] = useState([]);

  const fxgApiHost = useSelector((state) => state.getIn(['config', 'fxgApi']));

  useEffect(() => {
    const getDialCodes = async () => {
      setDialCodes(await fetchDialCodes({ fxgApiHost }));
    };

    getDialCodes();
  }, [fxgApiHost]);

  return (
    <FxPageContainer>
      {stepNo === 1 && (
        <ContactInformationDirectory
          setStepNo={setStepNo}
          selectedContact={selectedContact}
          setSelectedContact={setSelectedContact}
        />
      )}

      {stepNo === 2 && (
        <UpdateContact
          selectedContact={{
            userFullName: selectedContact.userFullName,
            userFirstName: selectedContact.userFirstName,
            userLastName: selectedContact.userLastName,
            userEmailId: selectedContact.userEmailId,
            phoneNumber: selectedContact.phoneNumber,
            role: selectedContact.contactType,
            countryId: selectedContact.countryId,
            environment: selectedContact.environment,
          }}
          setStepNo={setStepNo}
          baseBreadcrumb={contactInformationBreadcrumbs}
          finalBreadcrumb={updateContactBreadcrumb}
          pageHeaderTxt="Update Contact Information"
          actionButtonLabelTxt="Update Contact"
          performAnotherActionButtonTxt="Go to Contact Information"
          action={actionType.UPDATE_CONTACT.name}
          dialCodes={dialCodes}
        />
      )}
    </FxPageContainer>
  );
};

export default ContactInformation;
